export enum ESessionQueueItemInfoType {
  Warning,
  Success,
  Waiting,
  Matching,
  Calendar,
}
